module.exports = __webpack_public_path__ + "static/media/magnum-square.56132ef3.png";